import { render, staticRenderFns } from "./save-date-modal.vue?vue&type=template&id=8d51f160&scoped=true"
import script from "./save-date-modal.vue?vue&type=script&lang=js"
export * from "./save-date-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d51f160",
  null
  
)

export default component.exports